module.exports = __webpack_public_path__ + "media/applicants/techcrunch-17d2a6eb.png";